import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { Menu, Item } from "@zendeskgarden/react-menus";
import EllipsisIcon from "@zendeskgarden/svg-icons/src/26/ellipsis.svg";
import GripIcon from "@zendeskgarden/svg-icons/src/12/grip.svg";
import StarIcon from "@zendeskgarden/svg-icons/src/12/star-fill.svg";
import { Tag } from "@zendeskgarden/react-tags";
import { Spinner } from "@zendeskgarden/react-loaders";
import classnames from "classnames";
import t from "@zendesk/client-i18n-tools";
import { getCurrentBrandId } from "@zendesk/knowledge-context";
import MoveToModal from "../MoveToModal";
import styles from "./index.css";

export default class ArticleRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMoveToModalVisible: false,
    };

    this.onMoveToTop = this.onMoveToTop.bind(this);
    this.onEditClick = this.onEditClick.bind(this);
    this.onViewClick = this.onViewClick.bind(this);
    this.onMoveToClick = this.onMoveToClick.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
  }

  onMoveToTop(e) {
    e.stopPropagation();

    const { onMoveToTop } = this.props;
    onMoveToTop();
  }

  onEditClick(e) {
    e.stopPropagation();
    const { article } = this.props;
    window.open(
      `/knowledge/articles/${article.id}/edit?brand_id=${getCurrentBrandId()}`,
      "_blank"
    );
  }

  onViewClick(e) {
    e.stopPropagation();
    const { article } = this.props;
    window.open(article.html_url, "_blank");
  }

  onMoveToClick(e) {
    e.stopPropagation();
    this.setState({ isMoveToModalVisible: true });
  }

  onModalClose() {
    this.setState({ isMoveToModalVisible: false });
  }

  render() {
    const {
      article,
      testId,
      dragHandleProps,
      dragRef,
      dragProps,
      saving,
      success,
      dragging,
      onMoveTo,
    } = this.props;

    const { isMoveToModalVisible } = this.state;

    const menu = (
      <Menu
        data-test-id={testId && `${testId}-menu`}
        trigger={({ ref, isOpen }) => (
          <a
            ref={ref}
            aria-label={t("knowledge-arrange.section.menuAriaLabel")}
            tabIndex={0}
            className={classnames(styles.trigger, {
              [styles.open]: isOpen,
            })}
            data-test-id={testId && `${testId}-menu-trigger`}
          >
            <EllipsisIcon />
          </a>
        )}
      >
        <Item
          data-test-id={testId && `${testId}-edit`}
          onClick={this.onEditClick}
        >
          {t("knowledge-arrange.article.edit")}
        </Item>
        <Item
          data-test-id={testId && `${testId}-move-to`}
          onClick={this.onMoveToClick}
        >
          {t("knowledge-arrange.moveTo.menuItem")}
        </Item>
        <Item
          data-test-id={testId && `${testId}-move-to-top`}
          onClick={this.onMoveToTop}
        >
          {t("knowledge-arrange.article.sendToTop")}
        </Item>
        <Item
          data-test-id={testId && `${testId}-view`}
          onClick={this.onViewClick}
        >
          {t("knowledge-arrange.article.view")}
        </Item>
      </Menu>
    );

    return (
      <div
        className={classnames(styles.row, {
          [styles.dragging]: dragging,
          [styles.saving]: saving,
          [styles.success]: success,
        })}
        data-test-id={testId && `${testId}-row`}
        ref={dragRef}
        {...dragProps}
      >
        {isMoveToModalVisible && (
          <MoveToModal
            onMove={onMoveTo}
            onClose={this.onModalClose}
            name={article.title}
            destinationTypes={["Section"]}
          />
        )}

        <div
          role="button"
          tabIndex={0}
          className={styles.grip}
          data-test-id={testId && `${testId}-drag-handle`}
          {...dragHandleProps}
        >
          <GripIcon />
        </div>
        <div className={styles.content}>
          <div
            className={styles.name}
            data-test-id={testId && `${testId}-name`}
          >
            {article.title}
          </div>
          {article.promoted && <StarIcon className={styles.promoted} />}
          {article.user_segment && (
            <Tag className={styles.userSegment} type="blue">
              {article.user_segment.name}
            </Tag>
          )}
        </div>

        {saving ? (
          <div className={styles.loader}>
            <Spinner delayMs={0} />
          </div>
        ) : (
          menu
        )}
      </div>
    );
  }
}

ArticleRow.propTypes = {
  article: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    user_segment: PropTypes.shape({ name: PropTypes.string.isRequired }),
    promoted: PropTypes.bool,
    html_url: PropTypes.string.isRequired,
  }).isRequired,
  testId: PropTypes.string,
  dragHandleProps: PropTypes.object,
  dragProps: PropTypes.object,
  dragRef: PropTypes.func,
  saving: PropTypes.bool,
  success: PropTypes.bool,
  dragging: PropTypes.bool,
  onMoveTo: PropTypes.func.isRequired,
  onMoveToTop: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/ArticleRow/index.js